import Colunas from './static_data/colunasMoveis';
import ColunasFilterTags from './static_data/colunasFilterTagsMoveis';

export default {
    searchFieldMoveis: "",
    searchFieldExternalMoveis: "",

    rowsPerPageMoveis: 2,
    totalRowsMoveis: 0,
    pageFrom: 0,
    
    dataMoveis: [],
    dataMoveisSelected: [],
    opcoesGrupos: [],
    opcoesFamilias: [],
    escolhaGrupo: 0,
    escolhaFamilia: 0,
    isSelectFamiliasMoveisDisabled: true,

    statusMoveis: "Todos",

    colunasMoveis: Colunas,

    colunasFilterTagsMoveis: ColunasFilterTags,

    lastCardSelected: null,

    escolhaSituacaoMoveis: 0,
};